import React, { useEffect } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// Components
import { ButtonInvisible, ButtonPrimary } from "components/Buttons/Buttons";
import { Text } from "components/Text/Text";

// CSS
import styles from "./support-squad-donate-tokens-modal-enter-amount.module.scss";

// Localization
import { useTranslation } from "localization/localization";

// Constants
import { NavigationEnum } from "../../constants/constants";
const { CONFIRM } = NavigationEnum;

export const SupportSquadDonateTokensModalEnterAmount = (props) => {
    const {
        credits,
        handleChangeTokensToDonate,
        handleTriggerPurchaseFlow,
        isInvalidTokensToDonateAmount,
        setCurrentSection,
        setHeaderText,
        setHeaderSubText,
        selectedSquad,
        tokensToDonate,
    } = props;

    /**
     * Custom Hooks
     */

    const { t } = useTranslation("support-squad");

    /**
     * useEffect
     */

    useEffect(() => {
        setHeaderText(t("donate.enter_amount_title", { ns: "support_squad" }));
        setHeaderSubText(
            t("donate.enter_amount_subtitle", {
                ns: "support_squad",
                supporteeFirstName: selectedSquad.supporteeFirstName,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Constants
     */

    const canSubmit =
        tokensToDonate && tokensToDonate > 0 && !isInvalidTokensToDonateAmount;

    /**
     * End Hooks & Constants
     */

    function handleSubmit() {
        if (canSubmit) {
            setCurrentSection(CONFIRM);
        }
    }

    return (
        <div
            className={styles["support-squad-donate-tokens-modal-enter-amount"]}
        >
            <form className={styles.form} onSubmit={handleSubmit}>
                <label className={styles.label} htmlFor="tokensToDonate">
                    {t("donate.enter_amount_label", { ns: "support_squad" })}
                </label>
                <input
                    className={cx(styles.input, {
                        [styles["input--invalid"]]:
                            isInvalidTokensToDonateAmount,
                    })}
                    data-cy="donate-tokens-input"
                    name="tokensToDonate"
                    onChange={handleChangeTokensToDonate}
                    placeholder={0}
                    type="number"
                    value={tokensToDonate}
                />
                <span className={styles.subText}>
                    {t("donate.enter_amount_available_balance", {
                        ns: "support_squad",
                    })}
                    <span className={styles.number}>{credits}</span>
                </span>
                <div
                    className={cx(styles.errors, {
                        [styles["errors--active"]]:
                            isInvalidTokensToDonateAmount,
                    })}
                >
                    <span>
                        {t("donate.enter_amount_error", {
                            credits,
                            ns: "support_squad",
                        })}
                    </span>
                </div>
                <div className={styles.buttons}>
                    <ButtonPrimary
                        classes={styles.button}
                        cypressTestId="donate-tokens-modal-continue-button"
                        isDisabled={!canSubmit}
                        type="submit"
                    >
                        <Text>{t("continue", { ns: "common" })}</Text>
                    </ButtonPrimary>
                    <ButtonInvisible
                        classes={styles.button}
                        cypressTestId="donate-tokens-modal-purchase-button"
                        onClick={handleTriggerPurchaseFlow}
                    >
                        <Text>{t("buy_more_letters", { ns: "common" })}</Text>
                    </ButtonInvisible>
                </div>
            </form>
        </div>
    );
};

SupportSquadDonateTokensModalEnterAmount.propTypes = {
    credits: PropTypes.number,
    handleChangeTokensToDonate: PropTypes.func.isRequired,
    isInvalidTokensToDonateAmount: PropTypes.bool.isRequired,
    setCurrentSection: PropTypes.func.isRequired,
    setHeaderText: PropTypes.func.isRequired,
    setHeaderSubText: PropTypes.func.isRequired,
    tokensToDonate: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf([""]),
    ]),
};
